/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useMemo, useCallback } from 'react';
import { Box } from '@chakra-ui/core';
import { AnimatePresence } from 'framer-motion';
import { QuestionnaireTemplateStore } from '../../store/questionnaireTemplateModel';
import { QuestionElementHeader } from '../builderElements/formElements/QuestionElementHeader';
import { QuestionElementBody } from '../builderElements/formElements/QuestionElementBody';
import { AnimatedWrapper } from './withLayoutAnimation';

interface SortableElementProps {
  id: string;
  parentId: string | null;
  branch: string | null;
}

const BOX_BASE_STYLES = {
  bg: 'white',
  border: '2px solid',
  borderColor: 'rgba(174, 208, 255, 1)',
  borderRadius: 'lg',
  shadow: 'sm',
  transition: 'all 0.2s',
  marginBottom: 3,
  // _hover: { borderColor: 'rgba(92, 158, 250, 1)', shadow: 'md' },
  _focusWithin: { borderColor: 'rgba(92, 158, 250, 1)', shadow: 'xl' },
};

export const SortableElement = React.memo<SortableElementProps>(
  function SortableElement({ id, parentId, branch }) {
    const typeSelector = useCallback((state) => state.getElementValue(id, 'type'), [id]);
    const type = QuestionnaireTemplateStore.useStoreState(typeSelector);
    const setSelectedElementId = QuestionnaireTemplateStore.useStoreActions((actions) => actions.setSelectedElementId);

    const dataAttributes = useMemo(
      () => ({ 'data-element-id': id, 'data-parent-id': parentId || '', 'data-branch': branch || '', 'data-element-type': type }),
      [id, parentId, branch, type],
    );

    return (
      <AnimatePresence initial={false}>
        <AnimatedWrapper>
          <Box
            {...BOX_BASE_STYLES}
            {...dataAttributes}
            sx={{
              '&:has([aria-invalid="true"])': {
                borderColor: 'rgba(255, 0, 0, 0.4) !important',
              },
              '&:has([data-dragging])': {
                opacity: 0.5,
                transform: 'scale(0.98)',
                borderColor: 'rgba(92, 158, 250, 0.6)',
                borderStyle: 'dashed',
                pointerEvents: 'none',
              },
            }}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedElementId(id);
            }}
          >
            <QuestionElementHeader id={id} />
            <QuestionElementBody id={id} />
          </Box>
        </AnimatedWrapper>
      </AnimatePresence>
    );
  },
  // istanbul ignore next
  (prevProps, nextProps) => {
    // eslint-disable-next-line
    return prevProps.id === nextProps.id && prevProps.parentId === nextProps.parentId && prevProps.branch === nextProps.branch;
  },
);
